<template>
    <li class="nav-item dropdown" v-if="menu.children !== undefined">
      <a class="nav-link " href="#"  role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
        <span class="mr-1">{{menu.title}}</span>
        <em class="fas fa-angle-down ml-auto"></em>
      </a>
      <ul class="dropdown-menu" aria-labelledby="navbarPagesDropdown">
        <!-- Summary -->
        <template v-for="(data, i) in menu.children">
          <sub-menu-item  v-bind:key="i" v-if="data.children !== undefined && data.children.length > 0" :menu="menu.children[i]">
          </sub-menu-item>
          <router-link  v-bind:key="i" tag="li" class="menu-item" :to="data.path[0]" v-else-if="data.action.includes('view')">
            <a class="dropdown-item" >{{data.title}}</a>
          </router-link>
        </template>
      </ul>
    </li>
    <router-link tag="li" class="nav-item" :to="menu.path[0]" v-else-if="menu.action.includes('view')">
      <a class="nav-link">{{menu.title}}</a>
    </router-link>
</template>

<script>
import SubMenuItem from "./SubMenuItem";
export default {
  name: "MenuItem",
  components: {SubMenuItem},
  props:{
    menu:{
      type:Object
    }
  }
}
</script>